var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Filters a menu structure to show only the items allowed by `allowedRoutes`.
 *
 * This function recursively traverses `items` (which may be a flat array or
 * a nested array of `MenuItem`s) and sets the `visible` property based on
 * whether the route in the item's `command` exists in `allowedRoutes`.
 *
 * For menu items with children (`items`), it recurses and ensures the parent
 * is visible if any child is visible.
 *
 * @param {MenuItem[] | MenuItem[][]} items - The menu items to filter. Can be nested.
 * @param {string[]} allowedRoutes - List of allowed route paths. Only items whose
 *   `command` contains a navigate path in this list will be visible.
 * @returns {MenuItem[]} A filtered array of `MenuItem`s where `visible` is set
 *   according to permissions.
 * @author rajeev.k
 * @example
 * const menuItems: MenuItem[] = [
 *   { label: "Dashboard", command: () => navigate("/dashboard") },
 *   { label: "Admin", items: [
 *       { label: "Users", command: () => navigate("/admin/users") },
 *     ]
 *   }
 * ];
 * const allowedRoutes = ["/dashboard"];
 * const filtered = filterMenuItems(menuItems, allowedRoutes);
 * // filtered[0].visible === true
 * // filtered[1].visible === false (children not visible)
 */
export var filterMenuItems = function (items, allowedRoutes) {
    return items
        ? (items
            .map(function (item) {
            var _a, _b, _c;
            var isAllowed = allowedRoutes === null || allowedRoutes === void 0 ? void 0 : allowedRoutes.includes(((_c = (_b = (_a = item.command) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.match(/"([^"]+)"/)) === null || _c === void 0 ? void 0 : _c[1]) || "");
            // Check children recursively
            var filteredChildren = item.items ? filterMenuItems(item.items, allowedRoutes) : [];
            return __assign(__assign({}, item), { visible: isAllowed || filteredChildren.length > 0, items: filteredChildren.length > 0 ? filteredChildren : null });
        })
            .filter(function (item) { return item.visible; }))
        : [];
};
